export default "__VITE_ASSET__BDiZWp6o__"